$(() => {
  new Vue({
    el: document.querySelector(".v-loan-overview-cta-box-controller"),
  });
});
